import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/course/importer/courseImporterActions'

export default importerReducers(actions)
